import axios from './axios_web';

import * as actionTypes from './actionTypes';

export const signUpOTPStart = () => ({
  type: actionTypes.SIGN_UP_OTP_START,
});

export const signUpOTPSuccess = () => ({
  type: actionTypes.SIGN_UP_OTP_SUCCESS,
});

export const signUpOTPFail = (error) => ({
  type: actionTypes.SIGN_UP_OTP_FAIL,
  error,
});

export const verifyOTPReset = () => ({
  type: actionTypes.VERIFY_OTP_RESET,
});

export const signUpOTPBegin = (email, code, captchaToken) => (
  (dispatch) => {
    dispatch(verifyOTPReset());
    dispatch(signUpOTPStart());
    const url = '/signup';
    const data = {
      email,
      code,
      captcha_token: captchaToken,
    };
    axios.post(url, data)
      .then((response) => {
        if (response.status === 204) {
          dispatch(signUpOTPSuccess());
        } else {
          dispatch(signUpOTPFail(response.data.detail));
        }
      })
      .catch((err) => {
        let error = err.message;
        if (err.response && err.response.data) {
          error = err.response.data.error;
        }
        dispatch(signUpOTPFail(error));
      });
  }
);
